/** Digits only from a phone-like string. */
export function phoneDigits(raw) {
  return String(raw || '').replace(/\D+/g, '');
}

/**
 * Normalize to a 10-digit Indian mobile (optional leading 0 / 91).
 * @returns {{ ok: true, phone: string } | { ok: false, error: string }}
 */
export function normalizeIndianMobile(raw) {
  let digits = phoneDigits(raw);
  if (digits.length === 12 && digits.startsWith('91')) {
    digits = digits.slice(2);
  } else if (digits.length === 11 && digits.startsWith('0')) {
    digits = digits.slice(1);
  }
  if (!/^[6-9]\d{9}$/.test(digits)) {
    return { ok: false, error: 'Enter a valid 10-digit mobile number.' };
  }
  return { ok: true, phone: digits };
}

/** Same as normalizeIndianMobile, but empty input is allowed. */
export function validateOptionalIndianMobile(raw) {
  if (!String(raw || '').trim()) {
    return { ok: true, phone: '' };
  }
  return normalizeIndianMobile(raw);
}

/** Keep phone-friendly characters while typing. */
export function sanitizePhoneInput(raw, maxLen = 16) {
  return String(raw || '').replace(/[^\d+\s()-]/g, '').slice(0, maxLen);
}

/** Pragmatic email check aligned with typical FILTER_VALIDATE_EMAIL expectations. */
export function isValidEmail(raw) {
  const email = String(raw || '').trim();
  if (!email || email.length > 254) return false;
  if (/\s/.test(email)) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function validateCheckoutEmail(raw, { required = true } = {}) {
  const email = String(raw || '').trim();
  if (!email) {
    return required
      ? { ok: false, error: 'Enter your email address.' }
      : { ok: true, email: '' };
  }
  if (!isValidEmail(email)) {
    return { ok: false, error: 'Enter a valid email address.' };
  }
  return { ok: true, email };
}
